/* eslint-disable no-underscore-dangle */
/* eslint-disable object-property-newline */
import React, {
  createContext, useState, useContext, useMemo
} from 'react';
import PropTypes from 'prop-types';

export const DemoContext = createContext();
export const DemoConsumer = () => useContext(DemoContext);

const HeroDemoProvider = ({ children }) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [bookRef, setBookRef] = useState(null);
  const [currentSlide, setCurrentSlide] = useState({});
  const [pageFeatureText, setPageFeatureText] = useState(null);
  const [pageControls, _setPageControls] = useState([]);

  const setPageControls = (ctrls, i) => {
    _setPageControls((prevState) => {
      const newState = [...prevState];
      newState[i] = ctrls;
      return newState;
    });
  };

  const value = useMemo(() => ({
    currentPageIndex, setCurrentPageIndex,
    bookRef, setBookRef,
    currentSlide, setCurrentSlide,
    pageFeatureText, setPageFeatureText,
    pageControls, setPageControls
  }), [
    currentPageIndex,
    bookRef,
    currentSlide,
    pageFeatureText,
    pageControls
  ]);

  return (
    <DemoContext.Provider value={value}>
      {children}
    </DemoContext.Provider>
  );
};

HeroDemoProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default HeroDemoProvider;
